import { render } from "./BasicColumnChart.vue?vue&type=template&id=1c69c020"
import script from "./BasicColumnChart.vue?vue&type=script&lang=js"
export * from "./BasicColumnChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__